// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jk-0";
export var animationContainer = "_jk-1";
export var itemPrice = "_jk-a";
export var itemizedContent = "_jk-9";
export var itemizedHeader = "_jk-7";
export var itemizedRow = "_jk-8";
export var itemizedSection = "_jk-6";
export var modalContent = "_jk-2";
export var orderName = "_jk-3";
export var refundOption = "_jk-4";
export var refundOptionsContainer = "_jk-5";
export var shippingLabel = "_jk-b";
export var totalRow = "_jk-c";